import {useCallback, useContext} from 'react';
import {useSelector} from 'react-redux';
import {selectFabricArt} from '~/CreateFabricGreetingCard/reducers/fabricDesign/selectors';
import {Card} from '~/common/canvas/Card/Card';
import {Sections} from '~/common/FabricInvitation/EventCreateDesign/constants';
import {Envelope} from '~/common/fabric/Card/components/Envelope/Envelope';
import {useStamp} from '~/common/fabric/CreateDesign/components/Stamp/actions/useStamp';
import {EventCreateStampContext} from '~/common/fabric/CreateDesign/components/Stamp/EventCreateStampContext';
import {useMatchQuery} from '~library/hooks/useMatchQuery';
import {largishAndUp} from '~libSass/base/_exports.sass';
import './Stamp.sass';

export const Stamp = () => {
  const {canvas} = useContext(EventCreateStampContext);
  const fabricArt = useSelector(selectFabricArt);
  const {selectedStamp} = useStamp();
  const {matches: isDesktop} = useMatchQuery(`(min-width: ${largishAndUp})`);

  const refreshCanvasDimensions = useCallback(() => {
    canvas?.setCurrentDimensions();
  }, [canvas]);

  return (
    <div className="stamp">
      <div className="stamp__images">
        <Card
          className="stamp__images__card"
          fabricArt={fabricArt}
          redirectTo={isDesktop ? Sections.CARD_DESIGN : null}
        />
        <Envelope
          type="image"
          className="stamp__images__envelope"
          id="canvas__wrapper__stickers"
          selectedStamp={selectedStamp?.image}
          message="Recipient's name will go here"
          canvas
          onLoad={refreshCanvasDimensions}
        />
      </div>
    </div>
  );
};
